// extracted by mini-css-extract-plugin
export var postHero = "style-module--post-hero--14408";
export var postHero__author = "style-module--post-hero__author--dfcf9";
export var postHero__back = "style-module--post-hero__back--56e3f";
export var postHero__category = "style-module--post-hero__category--875ab";
export var postHero__content = "style-module--post-hero__content--6ebcf";
export var postHero__image = "style-module--post-hero__image--a2cee";
export var postHero__introduction = "style-module--post-hero__introduction--f32b0";
export var postHero__text = "style-module--post-hero__text--722d7";
export var postHero__title = "style-module--post-hero__title--8b34f";
export var postHero__version = "style-module--post-hero__version--6e9c4";
export var postHero__wrapper = "style-module--post-hero__wrapper--2e2ee";